import Icon from 'components/Icon';
import Seo from 'components/Seo';

export default function AboutPage() {
  return (
    <>
    <Seo title="About Us" description="Learn about Devlayar — free online tools built by Ethoss Technologies." path="/about" />
    <div className="static-page">
      <div className="container">
        <div className="static-hero">
          <div className="static-hero-icon"><Icon name="info" size={26} /></div>
          <h1>About Devlayar</h1>
          <p>Free online tools that just work — fast, private, and without signup.</p>
        </div>

        <div className="static-body">
          <h2>What is Devlayar?</h2>
          <p>Devlayar is a collection of free online tools for everyday tasks — working with PDFs, converting and compressing images, generating QR codes, building resumes, and more. Every tool is designed to be simple: open it, use it, and get your result in seconds. No account, no watermarks, no hidden limits.</p>

          <h2>Our Mission</h2>
          <p>We believe useful tools should be free and easy to use for everyone. Many online tools hide features behind paywalls or force you to sign up before you can do anything. Devlayar takes the opposite approach — the tools are free to use, and most of them run right inside your browser so your files stay on your own device.</p>

          <h2>Privacy First</h2>
          <p>Many of our tools — like image conversion, QR code generation, the case converter, and the resume builder — work entirely in your browser. That means your files and information never leave your device and are never uploaded to a server. For tools that do need processing, files are handled temporarily and not stored.</p>

          <h2>Who Built It?</h2>
          <p>Devlayar is built and maintained by <strong>Ethoss Technologies</strong>. We focus on building practical, reliable software for everyday needs. We keep improving Devlayar by adding new tools and refining the existing ones based on what people find useful.</p>

          <h2>Get in Touch</h2>
          <p>Have a suggestion, found a bug, or want a new tool added? We'd love to hear from you. Visit our <a href="/contact">Contact page</a> to reach out.</p>
        </div>
      </div>
    </div>
  </>
  );
}
